function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5 1.5C4.71875 1.5 4.5 1.71875 4.5 2C4.5 2.09375 4.53125 2.15625 4.59375 2.21875L9.75 6.21875C10.1875 6.5625 10.8125 6.5625 11.2812 6.21875L16.4062 2.21875C16.4688 2.15625 16.5 2.09375 16.5 2C16.5 1.71875 16.2812 1.5 16 1.5H5ZM16.5 4.03125L12.1875 7.375C11.1875 8.15625 9.8125 8.15625 8.8125 7.375L4.5 4.03125V9C4.5 9.28125 4.71875 9.5 5 9.5H16C16.2812 9.5 16.5 9.28125 16.5 9V4.03125ZM3 2C3 0.90625 3.90625 0 5 0H16C17.0938 0 18 0.90625 18 2V9C18 10.0938 17.0938 11 16 11H5C3.90625 11 3 10.0938 3 9V2ZM0.75 3C1.15625 3 1.5 3.34375 1.5 3.75V12C1.5 12.2812 1.71875 12.5 2 12.5H14.25C14.6562 12.5 15 12.8438 15 13.25C15 13.6562 14.6562 14 14.25 14H2C0.90625 14 0 13.0938 0 12V3.75C0 3.34375 0.34375 3 0.75 3Z",
  fill: "#636766"
});

function SvgEmailSent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSent);
export default __webpack_public_path__ + "static/media/email-sent.acd44b89.svg";
export { ForwardRef as ReactComponent };